import React from 'react';
import Button from '../Shared/components/controls/Button/index.js';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const ButtonComponent = (props) => {
  if (!props?.fields) {
    return <GenericPlaceholder componentName="Button" />;
  }
  const { link, style } = props?.fields;
  // The classname comes from the BE. Content author can choose what button style they need
  const className = style?.fields?.DropdownValue?.value || 'button-contained-primary';
  /**
   * Button is an abstarcted component that combines all different buttons in one place,
   * buttons styles can be selected from the BE from a dropdown.
   */
  return <Button link={{ ...link, value: { ...link.value, class: className } }} />;
};

export default ButtonComponent;
